import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ProgramCard from './programs/ProgramCard';
import ProgramsSkt from '../../../components/skeletons/ProgramsSkt';
import { Card } from '@mui/material';
import ProgramFilter from '../../../components/ui/organisms/profile/ProgramFilter';
import NoResultsFound from '../../../components/common/NoResultsFound';
import MajorProgramAccordion from '../components/accordions/MajorProgramAccordion';
import NoProgramsFound from './NoProgramsFound';
import useCareer from '../../../modules/educationalOffer/hooks/useCareer';
import Slider from '../../../components/common/Slider';
import CareerCard from './CareerCard';

const Programs = (props) => {
    const { report, programs } = props;

    // REDUX
    const loading = useSelector((state) => state.programs.listLoading);

    // HOOKS
    const { currentCareers, handleProductByLabel } = useCareer();

    // STATES
    const [values, setValues] = useState(programs);
    const [currentState, setCurrentState] = useState('Maestrías');
    const [sliderKey, setSliderKey] = useState(0);

    function normalizeString(str) {
        if (typeof str !== 'string') {
            return str;
        }

        if (typeof str.normalize !== 'function') {
            return str;
        }

        return str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    // Este useEffect se usa para filtrar los programas según el tipo de programa que es
    useEffect(() => {
        if (programs !== null) {
            const typeProgramFilters = {
                Doctorados: ['Doctorado', 'DBA'],
                Maestrías: ['Maestría', 'MBA'],
                Major: 'Major',
                Especializaciones: [
                    'Especialización',
                    'Especializacion',
                    'Especialización Online',
                ],
                Diplomados: 'Diplomado',
                'IMPACTO (+)': 'IMPACTO (+)',
            };

            if (typeProgramFilters[currentState]) {
                const filterTypes = typeProgramFilters[currentState];

                const filteredPrograms = programs.filter((value) => {
                    const programType = value.type
                        ? value.type
                        : value.type_program;
                    if (Array.isArray(filterTypes)) {
                        return filterTypes.some(
                            (filterType) =>
                                normalizeString(programType) ===
                                normalizeString(filterType)
                        );
                    }
                    return (
                        normalizeString(programType) ===
                        normalizeString(filterTypes)
                    );
                });

                setValues(filteredPrograms);
            }
        }
    }, [currentState, programs]);

    // Este useEffect se utiliza para posicionar la tab de izquierda a derecha donde primero encuentre una tab que no tenga info vacía
    useEffect(() => {
        const programPriority = {
            doctorado: 1,
            maestria: 2,
            mba: 3,
            major: 4,
            especializacion: 5,
            diplomado: 6,
            'IMPACTO (+)': 7,
        };

        const programTypesMap = {
            doctorado: 'Doctorados',
            maestria: 'Maestrías',
            mba: 'Maestrías',
            major: 'Major',
            especializacion: 'Especializaciones',
            diplomado: 'Diplomados',
            'IMPACTO (+)': 'IMPACTO (+)',
        };

        let highestPriority = Infinity;
        let currentState = null;

        if (programs) {
            programs.forEach((program) => {
                const normalizedType = normalizeString(program?.type);
                if (programPriority[normalizedType] < highestPriority) {
                    highestPriority = programPriority[normalizedType];
                    currentState = normalizedType;
                }
            });
        }

        if (currentState) {
            const stateForHandle = programTypesMap[currentState];
            handleCurrentState(stateForHandle);
            return;
        }
        handleCurrentState('Maestrías');
    }, [programs]);

    useEffect(() => {
        const currentTabLabel =
            currentState === 'Especializaciones'
                ? 'Especialización Online'
                : currentState === 'Maestrías'
                  ? 'Maestría'
                  : currentState === 'Doctorados'
                    ? 'Doctorado'
                    : currentState;
        handleProductByLabel(currentTabLabel);
        setSliderKey((prev) => prev + 1);
    }, [currentState]);

    // FUNCTION
    function handleCurrentState(newValue) {
        setCurrentState(newValue);
    }

    // RETURN
    if (programs === null || loading) {
        return <ProgramsSkt />;
    }

    const msgNoPrograms = `En este momento no contas con ${
        currentState === 'Maestrías'
            ? 'ninguna maestría activa'
            : currentState === 'Major'
              ? 'ningún major activo'
              : currentState === 'Doctorados'
                ? 'ningún doctorado activo'
                : currentState === 'Especializaciones'
                  ? 'ninguna especialización activa'
                  : 'ningún diplomado activo'
    }, pero te compartimos estas recomendaciones.`;

    const availableMsgPrograms = `${
        currentState === 'Maestrías'
            ? 'Maestrías disponibles'
            : currentState === 'Major'
              ? 'Majors disponibles'
              : currentState === 'Doctorados'
                ? 'Doctorados disponibles'
                : currentState === 'Especializaciones'
                  ? 'Especializaciones disponibles'
                  : 'Diplomados disponibles'
    }`;

    const linkToEducationalOffer = `${
        currentState === 'Maestrías'
            ? '/oferta-educativa?tab=Maestría'
            : currentState === 'Major'
              ? '/oferta-educativa?tab=Major'
              : currentState === 'Doctorados'
                ? '/oferta-educativa?tab=Doctorado'
                : currentState === 'Especializaciones'
                  ? '/oferta-educativa?tab=Especialización Online'
                  : '/oferta-educativa?tab=Diplomados'
    }`;

    return (
        <Wrapper values={values?.length}>
            <ProgramFilter
                currentState={currentState}
                handleCurrentState={handleCurrentState}
            />
            {/* TARJETAS DE PROGRAMAS */}
            <ProgramsContainer values={values?.length} report={report}>
                {values?.length === 0 || values === null ? (
                    <NoResultWrapper>
                        {!currentCareers && (
                            <NoProgramsFound
                                message={`¡Ups! No encontramos ${
                                    currentState === 'Maestrías'
                                        ? 'ninguna maestría'
                                        : currentState === 'Major'
                                          ? 'ningún major'
                                          : currentState === 'Doctorados'
                                            ? 'ningún doctorado'
                                            : currentState ===
                                                'Especializaciones'
                                              ? 'ninguna especialización'
                                              : 'ningún diplomado'
                                }`}
                            />
                        )}
                        {currentCareers && currentCareers.length > 0 && (
                            <>
                                <NoResultsMsg>{msgNoPrograms}</NoResultsMsg>
                                <CardFake>
                                    <Slider
                                        key={sliderKey}
                                        element={`glide-${currentState}`}
                                        array={currentCareers}
                                        card={CareerCard}
                                        to={linkToEducationalOffer}
                                        title={availableMsgPrograms}
                                        limit={7}
                                    />
                                </CardFake>
                            </>
                        )}
                    </NoResultWrapper>
                ) : values.length === 1 &&
                  values[0].has_study_plan === false ? (
                    <NoResultWrapper>
                        <NoResultsFound />
                    </NoResultWrapper>
                ) : (
                    values.map((program, index) => {
                        if (
                            program?.type === 'Maestría' ||
                            program?.type === 'Maestria' ||
                            program?.type === 'MBA'
                        ) {
                            return (
                                <MajorProgramAccordion
                                    program={program}
                                    key={index}
                                />
                            );
                        }
                        return (
                            <ProgramCard
                                program={program}
                                key={index}
                                report={report}
                            />
                        );
                    })
                )}
            </ProgramsContainer>
        </Wrapper>
    );
};

export default Programs;

const Wrapper = styled(Card)`
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    ${(p) => p.values !== 0 && 'gap: 2rem;'}
    padding: 1rem;
    background-color: #f9f9f9;
    box-shadow: none !important;

    &.jDuXnR {
        overflow: none !important;
    }
`;

const ProgramsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4rem;
    padding-top: 2rem;

    @media (max-width: 425px) {
        display: flex;
        flex-direction: column;
        gap: 4.5rem;
    }
`;

const NoResultWrapper = styled.div`
    width: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const NoResultsMsg = styled.div`
    padding: 1rem 1.5rem;
    font-size: 18px;
    font-weight: 700;
    color: #616161;

    @media (max-width: 768px) {
        font-size: 16px;
        padding: 1rem;
    }
`;

const CardFake = styled.div`
    position: relative;
    width: calc(100% - 48px);
    box-shadow: var(--shadow-strong);
    border-radius: var(--border-radius_sharp);
    background-color: #fff;
    padding: 24px 24px;
`;
